// https://github.com/microsoft/powerbi-client-react
import React, {useEffect, useState} from 'react';
import {Alert, Button, Grid} from '@mui/material';
import {EmbedType, PowerBIEmbed} from 'powerbi-client-react';
import {models} from 'powerbi-client';
import {Panel} from '../../components/Panel/Panel';
import {themeColors} from '../../theme/Theme';
import './analytics.css';
import {useGetDashboardToken} from '../../hooks/useGetDashboardToken';
import {useAccountContext, useAccountFull} from '../../contexts/AccountContext';
import Loading from '../../components/Loading/Loading';
import {ErrorPage} from '../ErrorPage';
import {dateDifferenceInDays} from '../../utils/dateUtils';
import {newUTCDate} from '../../utils/newUTCDate';

function ClientAnalyticsPage() {
  const {dashboardToken, getDashboardToken, errorDashboardToken} = useGetDashboardToken();
  const {account} = useAccountContext();
  const {accountFull: accountDetailed} = useAccountFull();
  const [hasDashboardFailed, setHasDashboardFailed] = useState(false);
  const hasBeenClientForOver24h = !accountDetailed
    ? true
    : dateDifferenceInDays({
        date: newUTCDate(
          accountDetailed?.dateBecameClient || accountDetailed?.dateCreated
        ),
        today: newUTCDate(),
      }) > 1;

  const basicFilter: models.IBasicFilter = {
    $schema: 'http://powerbi.com/product/schema#basic',
    target: {
      table: 'curoAccounts',
      column: 'AccountId',
    },
    operator: 'In',
    values: [account?.curoId],
    filterType: models.FilterType.Basic, // pbi.models.FilterType.BasicFilter
  };

  useEffect(() => {
    getDashboardToken();
  }, []);

  if (!hasBeenClientForOver24h) {
    return (
      <Panel title="Analytics">
        <Alert severity="warning">
          Analytics are unavailable for newly created accounts, please allow 24hrs.
        </Alert>
      </Panel>
    );
  }

  if (errorDashboardToken) {
    return <ErrorPage code="PowerBI Error" text={errorDashboardToken.message} />;
  }

  if (!dashboardToken) {
    return <Loading />;
  }

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Panel
            title="Analytics"
            style={{
              height: '100%',
            }}
            color={themeColors.chartPurple}
          >
            {hasDashboardFailed && (
              <Button
                variant="contained"
                color="secondary"
                onClick={() => getDashboardToken()}
              >
                Refresh dashboard
              </Button>
            )}
            <PowerBIEmbed
              key={`${dashboardToken?.embedToken}`}
              cssClassName="power-bi-client"
              embedConfig={{
                type: EmbedType.Report,
                id: dashboardToken?.id || undefined,
                embedUrl: dashboardToken?.embedUrl || undefined,
                accessToken: dashboardToken?.embedToken || undefined,
                tokenType: models.TokenType.Embed,
                // pageName: 'ReportSectionac0ff8b8691051e307ed',
                filters: [basicFilter],
              }}
              eventHandlers={
                new Map([
                  [
                    'loaded',
                    () => {
                      setHasDashboardFailed(false);
                    },
                  ],
                  [
                    'error',
                    () => {
                      setHasDashboardFailed(true);
                    },
                  ],
                ])
              }
            />
          </Panel>
        </Grid>
      </Grid>
    </>
  );
}

export default ClientAnalyticsPage;
